import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { track } from '../../modules/tracking';
import {
    POSTCODE_PLACEHOLDER,
    IE_PLACEHOLDER,
    MENUITEM,
    GO,
    NONE,
    LOCATION_PERMISSION,
    SEARCH_TITLE
} from '../../modules/constants';
let inst = 1;

/**
 * Restaurant locator component. Posts to existing website, we have no control over this API.
 *
 * @function
 * @param       {string} text              The text of the link.
 * @param       {string} className         An optional class to add to the existing component class attribute.
 * @param       {string} market            Current market (UK or IE)
 * @constructor
 */
function RestaurantForm({ text, className, market }) {
    const [coords, setCoords] = useState({ lat: null, lon: null });
    const baseURL =
        market === 'UK' ? 'https://www.nandos.co.uk' : 'https://www.nandos.ie';

    function success(coords) {
        setCoords({
            lat: coords.coords.latitude,
            lon: coords.coords.longitude
        });
    }

    useEffect(() => {
        if (coords.lat && coords.lon) {
            window.location.href = `${baseURL}/js/geo/convert/place?lat=${coords.lat}&lon=${coords.lon}&dest=/eat/restaurants/search`;
        }
    }, [coords]);

    return (
        <form
            action={`${baseURL}/eat/restaurants/search#results`}
            method='get'
            className={className}
            role={MENUITEM}
            onSubmit={() => {
                track('Restaurant locator: find')();
            }}
        >
            <label
                id={`search-${inst < 20 ? ++inst : (inst = 0)}`}
                htmlFor={`edit-search-${inst}`}
            >
                {text}
            </label>
            <input
                type='text'
                id={`edit-search-${inst}`}
                name='location'
                placeholder={
                    market === 'UK' ? POSTCODE_PLACEHOLDER : IE_PLACEHOLDER
                }
                aria-labelledby={`search-${inst}`}
                noValidate=''
                defaultValue=''
                value={undefined}
            />
            <button
                type='button'
                title={LOCATION_PERMISSION}
                className='geo'
                onClick={() => {
                    navigator.geolocation.getCurrentPosition(success);
                    track('Restaurant locator: Geolocate button click')();
                }}
            />
            <input
                id={`edit-submit${inst}`}
                type='submit'
                name='op'
                title={SEARCH_TITLE}
                value={GO}
            />
        </form>
    );
}

RestaurantForm.propTypes = {
    className: PropTypes.string,
    market: PropTypes.string,
    role: PropTypes.string,
    text: PropTypes.string
};

function RestaurantLocator(props) {
    const { inList, market } = props;

    if (inList) {
        return (
            <li role={NONE}>
                <RestaurantForm {...props} market={market} />
            </li>
        );
    }

    return <RestaurantForm {...props} />;
}

RestaurantLocator.propTypes = {
    inList: PropTypes.bool,
    market: PropTypes.string
};

export { RestaurantLocator };
